export default __webpack_public_path__ + "static/media/signup.a77ab041.svg";